import { Instituicao } from './instituicao';
export class TiposAtividades {
	id: number;
	descricao: string;
	instituicao:Instituicao;

}